// Google Ads tag loader + helpers.
// Tag is loaded ONLY after the visitor has accepted cookies (see CookieConsent).

export const GOOGLE_ADS_ID = "AW-18082504688";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let loaded = false;

/**
 * Inject the gtag.js script and initialise the Google Ads tag.
 * Safe to call multiple times — only loads once.
 */
export const loadGoogleAds = (id: string = GOOGLE_ADS_ID) => {
  if (typeof window === "undefined") return;
  if (loaded) return;

  // Re-enable in case it was previously disabled by a "reject" choice.
  (window as unknown as Record<string, unknown>)[`ga-disable-${id}`] = false;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);

  loaded = true;
};

/**
 * Disable the Google Ads tag for the current page.
 * Used when the visitor rejects cookies after previously accepting.
 */
export const disableGoogleAds = (id: string = GOOGLE_ADS_ID) => {
  if (typeof window === "undefined") return;
  (window as unknown as Record<string, unknown>)[`ga-disable-${id}`] = true;
};

/**
 * Fire a Google Ads conversion event.
 * @param sendTo Conversion label, e.g. "AW-18082504688/AbC-D_efGhIjKlMnOp"
 */
export const trackConversion = (
  sendTo: string,
  value?: number,
  currency: string = "GBP",
) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const payload: Record<string, unknown> = { send_to: sendTo };
  if (typeof value === "number") {
    payload.value = value;
    payload.currency = currency;
  }
  window.gtag("event", "conversion", payload);
};